export default {"option":"period-module__option___uaZjA","selected":"period-module__selected___Vs7x0"}
import '/home/jenkins/agent/workspace/_release_release_t3-widgets_15.1/packages/common/widgets/src/components/datepicker/period.module.css'
